import { render } from "./DocumentBody.vue?vue&type=template&id=6a82c387"
import script from "./DocumentBody.vue?vue&type=script&lang=js"
export * from "./DocumentBody.vue?vue&type=script&lang=js"

import "./DocumentBody.vue?vue&type=style&index=0&id=6a82c387&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__